import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div>
        <h1>Not Found</h1>
        <pre>{JSON.stringify(this.props, null, 2)}</pre>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound.js